export default "__VITE_ASSET__CZfOtUVJ__";